export const REPLAY = "REPLAY";
export const LIVE = "LIVE";

export const CHECKEDOUT = "CHECKED-OUT";

export const IN_STORE = "NOT-CHECKED-OUT";